import {
  WalletProviderPriority,
  getDefaultClient,
  getWalletProviderRegistry,
  hasExtension,
  registerExtension,
} from '@dynamic-labs-sdk/client/core';
import { getWallets } from '@wallet-standard/app';

import { registerSolanaNetworkProviderBuilder } from '../../registerSolanaNetworkProviderBuilder';
import { createWalletProviderFromSolanaStandardWallet } from '../utils/createWalletProviderFromSolanaStandardWallet';
import { hasAllRequiredFeatures } from '../utils/hasAllRequiredFeatures';

export const SOLANA_WALLET_STANDARD_EXTENSION_KEY = 'solanaWalletStandard';

/**
 * Adds the Solana Wallet Standard extension to the Dynamic client.
 *
 * This extension enables integration with wallets that implement the Solana Wallet Standard,
 * automatically detecting and registering compatible wallets for use with the Dynamic SDK.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 */
export const addSolanaWalletStandardExtension = (
  client = getDefaultClient()
): void => {
  if (
    hasExtension({ extensionKey: SOLANA_WALLET_STANDARD_EXTENSION_KEY }, client)
  ) {
    return;
  }

  registerExtension(
    { extensionKey: SOLANA_WALLET_STANDARD_EXTENSION_KEY },
    client
  );

  registerSolanaNetworkProviderBuilder(client);

  const walletProviderRegistry = getWalletProviderRegistry(client);

  const walletStandardWallets = getWallets()
    .get()
    .filter(hasAllRequiredFeatures);

  walletStandardWallets.forEach((walletStandardWallet) => {
    const walletProvider = createWalletProviderFromSolanaStandardWallet({
      dynamicClient: client,
      walletStandardWallet,
    });

    walletProviderRegistry.register({
      priority: WalletProviderPriority.WALLET_SELF_ANNOUNCEMENT_STANDARD,
      walletProvider,
    });
  });
};
